// extracted by mini-css-extract-plugin
export default {"button":"rm-z","reviewSort":"sm-z"};